export const API_URL = process.env.REACT_APP_API_URL;
export const AICRM_API_URL = process.env.REACT_APP_AICRM_API_URL;